<!-- ProToTeamDialog.vue -->
<template>
    <v-dialog
      :value="value"
      max-width="500"
      @input="$emit('input', $event)"
    >
      <v-card class="pro-to-team-dialog">
        <v-card-title class="dialog-header">
          <v-icon large color="warning" class="mr-3">mdi-account-group-outline</v-icon>
          <span>Upgrade to Team Pro</span>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-alert
            type="info"
            outlined
            dense
            class="mb-4"
          >
            <div class="alert-content">
              <v-icon small class="mr-2">mdi-information</v-icon>
              You're currently on a Pro subscription that will be replaced by Team Pro.
            </div>
          </v-alert>

          <div class="upgrade-info">
            <h4 class="subtitle-1 mb-3">What happens when you upgrade:</h4>

            <div class="info-item">
              <v-icon color="success" small>mdi-check-circle</v-icon>
              <span>Your Pro features will be included in Team Pro</span>
            </div>

            <div class="info-item">
              <v-icon color="success" small>mdi-check-circle</v-icon>
              <span>You'll gain team collaboration features</span>
            </div>

            <div class="info-item">
              <v-icon color="success" small>mdi-check-circle</v-icon>
              <span>You can invite team members to your workspace</span>
            </div>

            <div class="info-item">
              <v-icon color="warning" small>mdi-alert-circle</v-icon>
              <span>Your current Pro subscription will be prorated</span>
            </div>

            <div class="info-item" v-if="user.subscription_end_date">
              <v-icon color="info" small>mdi-calendar</v-icon>
              <span>
                Current Pro subscription ends:
                <strong>{{ formatDate(user.subscription_end_date) }}</strong>
              </span>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="pricing-info">
            <div class="price-comparison">
              <div class="current-plan">
                <span class="plan-label">Current:</span>
                <span class="plan-price">Pro - $149/month</span>
              </div>
              <v-icon>mdi-arrow-right</v-icon>
              <div class="new-plan">
                <span class="plan-label">New:</span>
                <span class="plan-price">Team Pro - $399/month (5 members)</span>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="$emit('input', false)"
            :disabled="loading"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="handleConfirm"
            :loading="loading"
          >
            Upgrade to Team Pro
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <script>
  export default {
    name: 'ProToTeamDialog',

    props: {
      value: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      handleConfirm() {
        this.$emit('confirm');
      },

      formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }
    }
  };
  </script>

  <style scoped>
  .pro-to-team-dialog {
    border-radius: 8px;
  }

  .dialog-header {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
    font-size: 20px;
    padding: 16px 24px;
  }

  .dialog-content {
    padding: 24px;
  }

  .alert-content {
    display: flex;
    align-items: center;
  }

  .upgrade-info {
    margin-top: 16px;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .pricing-info {
    background: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
  }

  .price-comparison {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }

  .current-plan, .new-plan {
    text-align: center;
  }

  .plan-label {
    display: block;
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
  }

  .plan-price {
    font-weight: 600;
    font-size: 16px;
  }

  .new-plan .plan-price {
    color: #f59e0b;
  }

  .dialog-actions {
    padding: 16px 24px;
    background: #fafafa;
  }
  </style>
